import { getValidURL } from './getValidURL';

const URL_PATTERN = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
const TRAILING_PUNCTUATION_PATTERN = /[),.!?:;]+$/;

type IDescriptionSegment =
  | {
      type: 'text';
      content: string;
    }
  | {
      type: 'link';
      url: string;
      trailingContent?: string;
    };

interface IExtractLinksFromTextResult {
  segments: IDescriptionSegment[];
}

function splitMatchedUrl(url: string): { sanitizedUrl: string; trailingContent: string } {
  const sanitizedUrl = url.replace(TRAILING_PUNCTUATION_PATTERN, '');

  return {
    sanitizedUrl,
    trailingContent: url.slice(sanitizedUrl.length),
  };
}

function extractLinksFromText(text: string): IExtractLinksFromTextResult {
  const segments: IDescriptionSegment[] = [];
  let lastMatchIndex = 0;

  text.replace(URL_PATTERN, (matchedUrl, _group, offset: number) => {
    const textBeforeLink = text.slice(lastMatchIndex, offset);

    if (textBeforeLink) {
      segments.push({
        type: 'text',
        content: textBeforeLink,
      });
    }

    const { sanitizedUrl, trailingContent } = splitMatchedUrl(matchedUrl);

    if (sanitizedUrl) {
      segments.push({
        type: 'link',
        url: getValidURL(sanitizedUrl),
        trailingContent,
      });
    }

    lastMatchIndex = offset + matchedUrl.length;

    return matchedUrl;
  });

  const trailingText = text.slice(lastMatchIndex);

  if (trailingText) {
    segments.push({
      type: 'text',
      content: trailingText,
    });
  }

  return {
    segments,
  };
}

export { extractLinksFromText };
